import { lazy } from "react";

const Layout1 = lazy(() => import("src/@bootstrap/template/@gull/layout/Layout1/Layout1"));
// const Layout2 = lazy(() => import("src/@bootstrap/template/@gull/layout/Layout2/Layout2"));
// const Layout3 = lazy(() => import("src/@bootstrap/template/@gull/layout/Layout3/Layout3"));

export const GullLayouts = {
  layout1: Layout1,
  // layout2: Layout2,
  // layout3: Layout3
};
